import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetEventLog from '@/modules/manage-member/api/hooks/useQueryGetEventLog'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import EventLogListing from '@/modules/manage-member/components/EventLog/components/EvenLogListing'
import { parseAsString, useQueryState } from 'nuqs'

function EventLogPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const { dateFilter } = useDateFilter()
	const [status] = useQueryState(
		'status',
		parseAsString.withOptions({ shallow: false }).withDefault(''),
	)
	const [tagEvent] = useQueryState(
		'tagEvent',
		parseAsString.withOptions({ shallow: false }).withDefault(''),
	)

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		startDate: dateFilter.startDate,
		endDate: dateFilter.endDate,
		status: status || undefined,
		tagEvent: tagEvent || undefined,
		operatorName: searchQuery || undefined,
	}

	const { data, isLoading } = useQueryGetEventLog(payload)

	return (
		<PageContainer>
			<EventLogListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
				filters={payload}
			/>
		</PageContainer>
	)
}

const GuardedEventLogPage = withUserPermission(EventLogPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_OPERATOR],
})

export default GuardedEventLogPage
